import { render, staticRenderFns } from "./PopupFromRight.vue?vue&type=template&id=0162cc42&scoped=true&"
import script from "./PopupFromRight.vue?vue&type=script&lang=ts&"
export * from "./PopupFromRight.vue?vue&type=script&lang=ts&"
import style0 from "./PopupFromRight.vue?vue&type=style&index=0&id=0162cc42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0162cc42",
  null
  
)

export default component.exports